/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * Categories API
 * API for managing product categories
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary Get all categories with optional filtering
 */

export const getCategoriesQuerySearchMax = 100;

export const getCategoriesQueryPageDefault = 1;

export const getCategoriesQueryPerPageDefault = 9999;
export const getCategoriesQueryPerPageMax = 10000;

export const getCategoriesQuerySortDefault = `display_order`;
export const getCategoriesQueryOrderDefault = `asc`;

export const GetCategoriesQueryParams = zod
    .object({
        brand_id: zod
            .number()
            .min(1)
            .nullish()
            .describe(
                "Filter categories to those with products under this brand; recounts products_count to brand-specific totals",
            ),
        exists_only: zod
            .boolean()
            .optional()
            .describe(
                "When true (and brand_id is not set), filter categories to those with at least one matching product site-wide; recounts products_count to live totals",
            ),
        search: zod.string().max(getCategoriesQuerySearchMax).optional().describe("Search keyword for category name"),
        parent_category_id: zod
            .number()
            .min(1)
            .nullish()
            .describe("Filter by parent category ID (null returns root categories)"),
        page: zod.number().min(1).default(getCategoriesQueryPageDefault).describe("Page number for pagination"),
        per_page: zod
            .number()
            .min(1)
            .max(getCategoriesQueryPerPageMax)
            .default(getCategoriesQueryPerPageDefault)
            .describe("Number of items per page"),
        sort: zod
            .enum(["display_order", "category_name", "category_id"])
            .default(getCategoriesQuerySortDefault)
            .describe("Field to sort by"),
        order: zod.enum(["asc", "desc"]).default(getCategoriesQueryOrderDefault).describe("Sort direction"),
    })
    .strict();

export const getCategories200ResponseDataItemsItemCategoryNameMax = 100;

export const getCategories200ResponseDataItemsItemCategoryIconMax = 40;

export const GetCategories200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                items: zod
                    .array(
                        zod
                            .object({
                                category_id: zod.number().nullish(),
                                category_name: zod
                                    .string()
                                    .max(getCategories200ResponseDataItemsItemCategoryNameMax)
                                    .optional(),
                                category_icon: zod
                                    .string()
                                    .max(getCategories200ResponseDataItemsItemCategoryIconMax)
                                    .optional()
                                    .describe(
                                        "SVG sprite symbol id for the category icon (e.g. vlf-cat-105). Empty when unset.",
                                    ),
                                parent_category_id: zod.number().nullish(),
                                display_order: zod.number().optional(),
                                review_config_id: zod.number().optional(),
                                products_count: zod.number().optional(),
                                is_active: zod.number().optional(),
                                created_at: zod.string().datetime({ offset: true }).optional(),
                                updated_at: zod.string().datetime({ offset: true }).optional(),
                            })
                            .strict(),
                    )
                    .optional(),
            })
            .strict()
            .optional()
            .describe(
                "CategoryController::index() returns ServiceBase-style {success, message, data} via jsonSuccess(['items' => ...]) — unpaginated (no pagination field; the page\/per_page query params below are accepted but currently unused server-side).",
            ),
    })
    .strict();

/**
 * @summary Get a single category by ID
 */

export const GetCategoryByIdParams = zod
    .object({
        category_id: zod.number().min(1).nullable(),
    })
    .strict();

export const getCategoryById200ResponseDataItemCategoryNameMax = 100;

export const getCategoryById200ResponseDataItemCategoryIconMax = 40;

export const GetCategoryById200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                item: zod
                    .object({
                        category_id: zod.number().nullish(),
                        category_name: zod.string().max(getCategoryById200ResponseDataItemCategoryNameMax).optional(),
                        category_icon: zod
                            .string()
                            .max(getCategoryById200ResponseDataItemCategoryIconMax)
                            .optional()
                            .describe(
                                "SVG sprite symbol id for the category icon (e.g. vlf-cat-105). Empty when unset.",
                            ),
                        parent_category_id: zod.number().nullish(),
                        display_order: zod.number().optional(),
                        review_config_id: zod.number().optional(),
                        products_count: zod.number().optional(),
                        is_active: zod.number().optional(),
                        created_at: zod.string().datetime({ offset: true }).optional(),
                        updated_at: zod.string().datetime({ offset: true }).optional(),
                    })
                    .strict()
                    .optional(),
            })
            .strict()
            .optional(),
    })
    .strict();
